import React from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { CircularProgress } from "@material-ui/core";
import { usePartnerListLazyQuery } from "../../../graphql/types";

interface IPartnerProps {
  client: any;
  isMulti?: boolean;
  onChange: (value: any[] | any) => void;
}

export function Partner({ client, onChange, isMulti = false }: IPartnerProps) {
  const [getList, { loading }] = usePartnerListLazyQuery({
    client,
    onCompleted: (data) => {
      setOptions(data?.MLPartnerList || []);
    },
  });

  const [options, setOptions] = React.useState<any[]>([]);
  const [value, setValue] = React.useState<any>([]);
  const [input, setInput] = React.useState<string>("");

  return (
    <Autocomplete
      multiple
      size="small"
      disableCloseOnSelect={true}
      value={value ?? []}
      loading={loading}
      onOpen={() => {
        if (!options.length) {
          getList({
            variables: {
              params: {
                count: 10,
                offset: 0,
                filter: [
                  {
                    field: "name",
                    operator: "LIKE",
                    values: [input],
                  },
                ],
              },
            },
          });
        }
      }}
      onChange={(e, value) => {
        setValue(value);
        onChange(value);
      }}
      inputValue={input}
      onInputChange={(e, name) => {
        setInput(name);
        getList({
          variables: {
            params: {
              count: 10,
              offset: 0,
              filter: [
                {
                  field: "name",
                  operator: "LIKE",
                  values: [name],
                },
              ],
            },
          },
        });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Партнер"
          variant="outlined"
          onClick={() => {
            console.log("1");
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
      getOptionSelected={(option, value) => {
        return option.id === value.id;
      }}
      getOptionLabel={(option) => option?.name}
      filterSelectedOptions
      options={options || []}
    />
  );
}
